import script from "./BulmaSubmitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulmaSubmitModal.vue?vue&type=script&setup=true&lang=ts"

import "./BulmaSubmitModal.vue?vue&type=style&index=0&id=61857853&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61857853"]])

export default __exports__